import Vue from 'vue'
import {Lazyload, NavBar} from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';
import { Button } from 'vant';
import { Cell, CellGroup } from 'vant';
import { Form } from 'vant';
import { Field } from 'vant';
import { PullRefresh } from 'vant';
import { List } from 'vant';
import { ActionSheet } from 'vant';
import { Dialog } from 'vant';
import { Toast } from 'vant';
import { Overlay } from 'vant';
import { Popover } from 'vant';
import { SwipeCell } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Grid, GridItem } from 'vant';
import { Picker } from 'vant';
import { Loading } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Search } from 'vant';
 import { Sticky } from 'vant';
import { Step, Steps } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Area } from 'vant';
import { Col, Row } from 'vant'
Vue.use(Col);
Vue.use(Row);
Vue.use(Area);
import { Popup } from 'vant';
import { Pagination } from 'vant';

Vue.use(Pagination);
Vue.use(Popup);
// import { Lazyload } from 'vant';
// Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Step);
Vue.use(Steps);
Vue.use(NavBar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Form);
Vue.use(Field);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Overlay);
Vue.use(Popover);
Vue.use(SwipeCell);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Picker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Loading);
Vue.use(Search);
 Vue.use(Sticky);
Toast.setDefaultOptions({ duration: 2000,  position: 'top' })


